module.exports = __webpack_public_path__ + "img/6.0c888836.jpg";